import { axiosGetHandler,  axiosPostHandler } from '../config'

// 获取活动模板图片流组件分页数据接口
export function getData (args) {
	let url = '/bbs/app/write_box/recommend'
	return axiosGetHandler(url, args)
}